export default __webpack_public_path__ + "static/media/Devaansh_Kakeri_.4f817711.pdf";